import TableSearch from '../../components/tabel-search/tabel-search'
import Table from '../../components/table/table'
import EditForm from '../../components/edit-form/edit-form'
import Steps from '../../components/timeline/timeline'
import webSock from '../../components/webSock/webSrom'

function plugins(Vue) {
    Vue.component('TableSearch', TableSearch)
    Vue.component('Table', Table)
    Vue.component('EditForm', EditForm)
    Vue.component('Steps', Steps)
    Vue.component('webSock', webSock)
}

export default plugins
